import React, { Component } from 'react';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import LogsTable from './LogsTable';
import GridStats from './GridStats';
import { ErrorAlert, InfoAlert, WarningAlert } from 'components/alerts';
import './style.scss';

class Statistics extends Component {
    state = {};

    renderLogsTableContent = () => {
        const { syncroLogs, integration, literals, integrationLogo } = this.props;
        if (syncroLogs && syncroLogs === 'error getting data') {
            return (
                <ErrorAlert
                    title={
                        <Literal
                            literal={
                                literals['label_error_getting_logs_data_integration'] ||
                                'label_error_getting_logs_data_integration'
                            }
                        />
                    }
                    shrink={true}
                />
            );
        } else if (syncroLogs && syncroLogs.logs && syncroLogs.logs.length === 0) {
            return (
                <InfoAlert
                    title={
                        <Literal
                            literal={
                                literals['label_no_logs_data_integration'] ||
                                'label_no_logs_data_integration'
                            }
                        />
                    }
                    shrink={true}
                />
            );
        } else if (syncroLogs && syncroLogs.logs && syncroLogs.logs.length > 0) {
            return (
                <div className="integrations-log-table-container">
                    <div className="integrations-statistics-desc">
                        <Literal
                            literal={
                                literals['label_logs_description_integration'] ||
                                'label_logs_description_integration'
                            }
                        />
                    </div>
                    <LogsTable
                        logData={syncroLogs}
                        literals={literals}
                        integration={integration}
                        integrationLogo={integrationLogo}
                    />
                </div>
            );
        } else {
            return (
                <InfoAlert
                    title={
                        <Literal
                            literal={
                                literals['label_getting_logs_data_integration'] ||
                                'label_getting_logs_data_integration'
                            }
                        />
                    }
                    shrink={true}
                />
            );
        }
    };

    renderStatsContent = () => {
        const { syncroStats, literals } = this.props;
        if (syncroStats && syncroStats === 'error getting data') {
            return (
                <ErrorAlert
                    title={
                        <Literal
                            literal={
                                literals['label_error_getting_stats_data_integration'] ||
                                'label_error_getting_stats_data_integration'
                            }
                        />
                    }
                    shrink={true}
                />
            );
        } else if (
            syncroStats &&
            syncroStats.data &&
            syncroStats.data.entities &&
            syncroStats.data.entities.length > 0
        ) {
            return (
                <div>
                    <div className="integrations-statistics-desc">
                        <Literal
                            literal={
                                literals['label_stats_description_integration'] ||
                                'label_stats_description_integration'
                            }
                        />
                    </div>
                    <GridStats syncroStats={syncroStats} />
                </div>
            );
        } else if (
            syncroStats &&
            syncroStats.data &&
            syncroStats.data.entities &&
            syncroStats.data.entities.length === 0
        ) {
            return (
                <InfoAlert
                    title={
                        <Literal
                            literal={
                                literals['label_no_stats_data_integration'] ||
                                'label_no_stats_data_integration'
                            }
                        />
                    }
                    shrink={true}
                />
            );
        } else {
            return (
                <InfoAlert
                    title={
                        <Literal
                            literal={
                                literals['label_getting_stats_data_integration'] ||
                                'label_getting_stats_data_integration'
                            }
                        />
                    }
                    shrink={true}
                />
            );
        }
    };

    render() {
        const { cronstatus, literals } = this.props;
        return (
            <div className="integration-statistics-container">
                {cronstatus === 'no cron' ? (
                    <WarningAlert
                        title={
                            <Literal
                                literal={
                                    literals['label_cofiguration_missed_integration'] ||
                                    'label_cofiguration_missed_integration'
                                }
                            />
                        }
                        text={
                            <Literal
                                literal={
                                    literals['label_cofiguration_missed_desc_integration'] ||
                                    'label_cofiguration_missed_desc_integration'
                                }
                            />
                        }
                        iconDisplay={'icon'}
                        shrink={true}
                    />
                ) : (
                    <div>
                        {this.renderStatsContent()}
                        {this.renderLogsTableContent()}
                    </div>
                )}
            </div>
        );
    }
}

export default Statistics;
